import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Numeric, Separator } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'

import { ExploreDevHoldingsInfo } from './explore-dev-holdings-info'

import type { PairModel } from '@root/entities/pair'

interface Props {
  pair: PairModel
}

const CloseArea = ({ pair }: Props) => {
  const { t } = useTranslation()
  const [auditData] = useAtom(
    (ctx) => ctx.spy(pair.audit).checks.ownerTokenBalance,
  )

  const renderAmount = () => {
    if (auditData.percent === 0) {
      return undefined
    }

    return (
      <>
        <Numeric value={auditData.percent} preset="percents" />%
      </>
    )
  }

  return (
    <Root>
      <TitleGroup>
        <Title>{t('common.dev_holdings')}</Title>
        <Percent data-status={auditData.status}>{renderAmount()}</Percent>
      </TitleGroup>
      <BodySeparator variant="solid" color="var(--backgroundA-3)" />
      <ExploreDevHoldingsInfo.CloseArea pair={pair} />
    </Root>
  )
}

const ClickArea = ({ pair }: Props) => (
  <ExploreDevHoldingsInfo.ClickArea pair={pair} />
)

export const ExploreDevHoldingsTooltip = {
  CloseArea,
  ClickArea,
}

const Root = styled.div`
  display: grid;
`

const TitleGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 8px;
`

const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: var(--text-12);
`
const Percent = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;

  &[data-status='Safe'] {
    color: var(--success-9);
  }
  &[data-status='Danger'] {
    color: var(--error-9);
  }
  &[data-status='Warning'] {
    color: var(--warning-9);
  }
`
const BodySeparator = styled(Separator)`
  margin: 8px 0;
`
